import { EditOutlined } from "@ant-design/icons";
import { GeneralDrawer } from "@components/general-drawer";
import { InfoIcon } from "@components/icons/Icons";
import { SCREEN, useWindowSize } from "@components/window-size-provider";
import useEnforceLoggedIn from "@hooks/useEnforceLoggedIn";
import { NotificationType, showNotification } from "@lib/notification";
import {
    usePartnerAddRemoveExportableFieldsMutation
} from "@ppServices/Partners";
import { Button, Checkbox, Col, Collapse, Form, Popover, Row } from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import { useEffect, useState } from "react";

const ManageDataFields = ({ form, fields, onFinish }) => {

    const [checkedValues, setCheckedValues] = useState({});

    const handleCheckboxChange = (value, checked) => {
        setCheckedValues(prevState => ({
            ...prevState,
            [value]: checked,
        }));
    };

    useEffect(() => {
        if (fields) {
            setCheckedValues(fields
                .filter(f => !!f.active)
                .map(f => {
                    return {
                        [f.id]: true
                    }
                }).reduce((acc, cur) => {
                    const key = Object.keys(cur)[0];
                    acc[key] = cur[key];
                    return acc;
                }, {})
            );
        }
    }, [fields])

    const hendleFinish = (values) => {
        const keys = Object.entries(checkedValues)
            .filter(([_, value]) => value === true)
            .map(([key]) => parseInt(key));

        onFinish({ ...values, ids: keys })
    }

    return (
        <Form
            form={form}
            onFinish={(values) => hendleFinish(values)}
            wrapperCol={{ span: 15 }}
            labelCol={{ span: 9 }}
            layout="horizontal"
        >
            <Form.Item name="id">

                <div
                    className={`checkbox-list`}
                >

                    {fields?.map((opt) => (

                        <Checkbox
                            className={`checkbox`}
                            key={opt.value}
                            value={opt.value}
                            checked={!!checkedValues[opt.value]}
                            onChange={e => handleCheckboxChange(opt.value, e.target.checked)}
                        >
                            {opt.niceName}

                            <Popover
                                key={opt.value}
                                placement="top"
                                content={opt.code}
                            >
                                <Button
                                    className="info-icon"
                                    type="link"
                                    shape="circle"
                                    icon={<InfoIcon />}
                                />

                            </Popover>

                        </Checkbox>

                    ))}

                </div>

            </Form.Item>

        </Form>);
}

const ManageFieldsButton = ({ type = 'link', className = '', exportableFields, onFilterChange }) => {

    const [form] = Form.useForm();

    const { user } = useEnforceLoggedIn();

    const windowDimensions = useWindowSize();

    const [showFilters, setShowFilters] = useState<boolean>(false);

    const [fields, setFields] = useState<any>([]);

    const [setExportableFields, exportableFieldsResults] = usePartnerAddRemoveExportableFieldsMutation();

    useEffect(() => {
        if (exportableFieldsResults.data?.exportableFields.length > 0) {
            showNotification('Field Updated', NotificationType.SUCCESS);
            setShowFilters(false);
        }

        if (exportableFieldsResults?.data?.exportableFields === false) {
            let message = 'Error Updating Field.';
            showNotification(message, NotificationType.ERROR);
        }
        onFilterChange(exportableFieldsResults.data?.activeElements);
    }, [exportableFieldsResults]);

    useEffect(() => {
        if (exportableFields) {
            setFields(exportableFields);
        }

    }, [exportableFields])

    const onClose = () => {
        setShowFilters(false);
    };

    const handleFinish = (values) => {
        let { ids } = values;
        let exportIds = fields?.map((field) => {
            let isActive = ids?.includes(field.id) || false;
            return {
                id: field.id,
                active: isActive,
            };
        });

        setExportableFields({
            userId: user.id,
            fieldIds: exportIds,
        });
    };

    const handleSubmitForm = () => {
        form.submit();
    };

    return (
        <>
            <Button
                className="greyButton"
                size={"large"}
                onClick={() => setShowFilters(true)}
            >

                {windowDimensions.up(SCREEN.SM)
                    && (<span className={className}>
                        Manage Fields
                    </span>)}
                <EditOutlined className="font-12" />

            </Button>

            <GeneralDrawer
                title={`Manage Data Fields`}
                visible={showFilters}
                onClose={onClose}
                renderFooter={
                    <Row justify="center">
                        <Col >
                            <Button
                                loading={!!exportableFieldsResults.isLoading}
                                className="outlineButton thickButton width-250px"
                                onClick={handleSubmitForm}
                            >
                                {exportableFieldsResults.isLoading ? `` : `Save`}
                            </Button>
                        </Col>
                    </Row>
                }
            >

                <Row className={`pp-settings-drawer`}>

                    <Col span={`24`}>
                        <p>Select the data fields you wish to have included on your CSV export.  If you would like to add additional custom data fields, please contact your CovrPrice Customer Service Representative.</p>
                    </Col>

                    <Col span={`24`}>

                        <Collapse
                            defaultActiveKey={['0', '1']}
                            expandIconPosition={"end"}
                            ghost
                        >
                            <CollapsePanel
                                key={"0"}
                                header={`Standard Terms`}
                            >

                                <ManageDataFields
                                    form={form}
                                    fields={fields}
                                    onFinish={handleFinish}
                                />


                            </CollapsePanel>

                        </Collapse>

                    </Col>

                </Row>

            </GeneralDrawer>
        </>
    )
};

export default ManageFieldsButton;

